import React from 'react';
import './FlippingCard.css';

export default function FlippingCard({ frontContent, backContent, children }) {
  return (
    <div className="flipping-card-container">
      <div className="flipping-card">
        {/* Front Face */}
        <div className="flipping-card-front">
          {frontContent || children}
        </div>
        {/* Back Face */}
        <div className="flipping-card-back">
          {backContent}
        </div>
      </div>
    </div>
  );
}
